import {ChangeEvent} from 'react';

interface IProps {
  croppedImageFile: File | null;
  onImageRemove: () => void;
  onImageChange: (e: ChangeEvent<HTMLInputElement>) => void;
  variant?: 'sm' | 'md';
  inputId?: string; // Unique ID for each instance
}

const ImageUploadBox = ({
  croppedImageFile,
  onImageRemove,
  onImageChange,
  variant = 'md',
  inputId = 'imageUpload',
}: IProps) => {
  return (
    <section className="flex flex-col items-start justify-center">
      {croppedImageFile ? (
        <div className="flex flex-col items-start w-full">
          <div
            className={`${
              variant === 'sm' ? 'size-16' : 'size-24'
            } rounded-lg border-dashed border-[2px] border-gray-700 relative overflow-hidden`}
          >
            <div
              className={`m-[4px] absolute flex items-center justify-center text-white bg-white rounded-lg ${
                variant === 'sm' ? 'left-0 top-0' : 'left-2 top-2 p-1'
              }`}
            >
              <i
                className="m-[1px] text-xl text-red-600 cursor-pointer icon-nameDelete"
                onClick={onImageRemove}
              />
            </div>
            <img
              className="object-cover w-full h-full"
              src={URL.createObjectURL(croppedImageFile)}
              alt="uploaded_document"
            />
          </div>
        </div>
      ) : (
        <div>
          <label
            htmlFor={inputId}
            className={`flex items-center justify-center text-md ${
              variant === 'sm' ? 'size-16' : 'size-24'
            } rounded-lg border-[2px] border-dashed text-gray-700 flex-col cursor-pointer`}
          >
            <i className="text-4xl text-gray-400 icon-namePlus-4" />
          </label>
          <input
            className="hidden"
            type="file"
            id={inputId}
            name={inputId}
            accept="image/png, image/jpeg"
            onChange={onImageChange}
          />
        </div>
      )}
    </section>
  );
};

export default ImageUploadBox;
